import bg from "@assets/gradient-bg.webp"
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/ui/table"
import { Button } from "@/shared/ui/button"
import { useNavigate } from "react-router-dom"

type Feature = {
  feature: string
  sia: boolean
  generic: boolean
}

const features: Feature[] = [
  { feature: "Zero Prompt", sia: true, generic: false },
  { feature: "Zero Slop", sia: true, generic: false },
  { feature: "Evolves with your brand", sia: true, generic: false },
  { feature: "Sounds human", sia: true, generic: false },
  { feature: "Understands context", sia: true, generic: false },
]

const InformationNew = () => {
  const navigate = useNavigate()

  return (
    <div
      style={{ backgroundImage: `url(${bg})` }}
      className="min-h-screen w-full bg-cover bg-center bg-no-repeat flex flex-col relative items-center pt-32 py-12 overflow-hidden"
    >
      {/* Section 1 */}
      <div className="w-full min-h-[80vh] flex flex-row gap-2 max-w-6xl mx-auto relative px-5">
        <div className="max-md:hidden bottom-1 right-1 w-1/3 md:w-1/2 md:h-full flex items-center justify-between">
          <img
            src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9YydWee1NMFK6AZWV9Qv1IGE4zy5CdbBeqfDP"
            className="w-full md:w-10/12 h-auto"
          />
        </div>

        <div className="w-full md:w-1/2 h-full flex flex-col justify-center gap-3 pe-5">
          <h3 className="pt-20 pb-8 font-montserrat font-bold text-2xl sm:text-5xl text-[#390088]">
            Brand Intelligence <br /> Without the Slop.
          </h3>
          <img
            src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9YydWee1NMFK6AZWV9Qv1IGE4zy5CdbBeqfDP"
            className="w-10/12 sm:1/3 h-auto mx-auto block md:hidden"
          />

          <Table className="w-full h-[40vh]">
            <TableCaption>Features siAi provides</TableCaption>
            <TableHeader>
              <TableRow>
                <TableHead className="md:p-4">Feature</TableHead>
                <TableHead className="md:p-4">siAi</TableHead>
                <TableHead className="md:p-4">Generic AI</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {features.map((feature) => (
                <TableRow key={feature.feature}>
                  <TableCell className="font-medium md:p-4">{feature.feature}</TableCell>
                  <TableCell className="md:p-4">{feature.sia ? "✅" : "❌"}</TableCell>
                  <TableCell className="md:p-4">{feature.generic ? "✅" : "❌"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>

      {/* Section 2 */}
      <div className="w-full min-h-[80vh] flex flex-row gap-2 max-w-6xl mx-auto relative px-5">
        <div className="w-full md:w-1/2 h-full flex flex-col justify-center gap-3 pe-5">
          <h3 className="pt-20 pb-8 font-montserrat font-bold text-2xl md:text-5xl text-black">
            Built for brands that refuse to sound
            <span className="text-[#9829FF] ps-2">Average.</span>
          </h3>
          <img
            src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9HLrtT4NMor0Nh4Jfi5AVDOw6lmEq82F9dasj"
            className="w-full h-auto block md:hidden"
          />
          <p className="font-poppins tracking-wide text-gray-500">
            Whether you’re a startup finding your voice or a global brand scaling storytelling, siAi adapts.
          </p>
          <p className="font-poppins pb-3 tracking-wide text-gray-500">
            Creators use it to stay consistent. Teams use it to scale campaigns. Leaders use it to protect what
            matters most — their brand’s identity.
          </p>
          <Button
            className="bg-gradient-to-b from-[#320177] to-[#5D02DD] rounded-full font-poppins px-5 py-6 w-fit"
            onClick={() => navigate("/contact")}
          >
            Join as a Design Partner
          </Button>
        </div>

        <div className="hidden md:block w-1/3 md:w-1/2 md:h-full">
          <img
            src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9HLrtT4NMor0Nh4Jfi5AVDOw6lmEq82F9dasj"
            className="w-full h-auto"
          />
        </div>
      </div>
    </div>
  )
}

export default InformationNew
